import * as React from 'react';
import { Logo } from '../Logo';
import * as styles from './styles.css';
export function View(_ref) {
  var showLogo = _ref.showLogo,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, showLogo && /*#__PURE__*/React.createElement(Logo, null), children);
}